import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'titleCase',
    standalone: false
})
export class TitleCasePipe implements PipeTransform {
  private readonly exclusionLabels = ['NPI', 'NPIs'];

  transform(text: string) {
    const npi = this.exclusionLabels.find(
      (title) => title.toLocaleLowerCase() === text.toLocaleLowerCase()
    );

    return (
      npi
      || text
        .replace(/([A-Z])/g, (match) => ` ${match}`)
        .replace(/^./, (match) => match.toUpperCase())
        .trim()
    );
  }
}
